var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-3 orange--text"},[_vm._v(" #"+_vm._s(_vm.systemId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }